module.exports = __webpack_public_path__ + "static/media/Emi.13bc3a9c.png";